import React__default from 'react';
import { ProductDetailPrice } from '@grandvisionhq/fun-products';
import { getAttrValue } from '@grandvisionhq/utils';
import { PackageQuantityDropdown } from '../../../../ConfigureContactLenses/components/PackageQuantityDropdown/PackageQuantityDropdown.js';
import { getPrice } from '../../../../helpers.js';

const getPackageObject = (variant)=>{
    const price = getPrice(variant);
    var ref, ref1;
    return {
        label: String(getAttrValue(variant, 'packageOption')),
        value: String(variant.sku),
        subtext: '',
        aside: /*#__PURE__*/ React__default.createElement(ProductDetailPrice, {
            originalPrice: (ref = price === null || price === void 0 ? void 0 : price.originalPrice) !== null && ref !== void 0 ? ref : 0,
            discountedPrice: (ref1 = price === null || price === void 0 ? void 0 : price.discountedPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            currency: price === null || price === void 0 ? void 0 : price.currency,
            customSize: "small"
        })
    };
};
const PackageSelector = ({ label , handleVariantPick , variants , selectedPackage  })=>{
    const packageItems = React__default.useMemo(()=>variants.map(getPackageObject)
    , [
        variants
    ]);
    const handlePackSizeChange = React__default.useCallback((packageOption, event)=>{
        handleVariantPick(event, packageOption.value, packageOption.label);
    }, [
        handleVariantPick
    ]);
    return /*#__PURE__*/ React__default.createElement(PackageQuantityDropdown, {
        onChange: handlePackSizeChange,
        title: packageItems[0].value,
        label: label,
        items: packageItems,
        selectedSize: selectedPackage
    });
};
var PackageSelector$1 = PackageSelector;

export { PackageSelector$1 as default };
//# sourceMappingURL=PackageSelector.js.map
